import {SessionStorageKey, getFromSessionStorage, setInSessionStorage} from "../sessionStorage";
import {useSessionStorageItem} from "./useBrowserStorage";

export const setSessionId = (id: string) => setInSessionStorage(SessionStorageKey.SessionId, id);

export const getSessionId = () => getFromSessionStorage(SessionStorageKey.SessionId);

export const useSessionId = () => useSessionStorageItem(SessionStorageKey.SessionId);
